import { FC, useState } from 'react';

import { clsx } from 'clsx';

import { ProfileProductCard } from '../../../../components/shared/ProfileProductCard';
import { Button } from '../../../../components/ui/Button';
import { CartonProduct } from '../../../../types';

type CardAction = {
    action: () => void;
    bg: string;
    className?: string;
    text: string;
    label: string;
    mobileLabel?: string;
};

interface Props {
    product: CartonProduct;
    price?: number;
    amount: number;
    loading: boolean;
    eagerLoadImage: boolean;
    toggled: boolean;
    onToggle: () => void;
    actions: CardAction[];
}

export const ProductCardToggle: FC<Props> = ({
    product,
    price,
    amount,
    loading,
    eagerLoadImage,
    toggled,
    onToggle,
    actions,
}) => {
    const [hovered, setHovered] = useState(false);

    const overlayVisible = toggled || hovered;

    return (
        <div
            className={clsx('group relative cursor-pointer', {
                'pointer-events-none': loading,
            })}
            onClick={() => onToggle()}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {!loading && (
                <div
                    className={clsx(
                        'absolute z-1 flex h-full w-full flex-col justify-center gap-6 rounded-2xl bg-primary/30 p-6 backdrop-blur-xs transition-all sm:group-hover:scale-105',
                        overlayVisible
                            ? 'pointer-events-auto opacity-100'
                            : 'pointer-events-none opacity-0',
                    )}
                >
                    {actions.map(
                        ({
                            bg,
                            className,
                            text,
                            label,
                            mobileLabel,
                            action,
                        }) => {
                            return (
                                <Button
                                    className={
                                        className ??
                                        `bg-${bg} hover:bg-${bg}/90 text-${text} border-2 border-primary`
                                    }
                                    variant="secondary"
                                    size="sm"
                                    key={label}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        action();
                                    }}
                                >
                                    {mobileLabel ? (
                                        <>
                                            <span className="sm:hidden">
                                                {mobileLabel}
                                            </span>
                                            <span className="hidden sm:inline">
                                                {label}
                                            </span>
                                        </>
                                    ) : (
                                        label
                                    )}
                                </Button>
                            );
                        },
                    )}
                </div>
            )}
            <ProfileProductCard
                product={product}
                price={price}
                amount={amount}
                loading={loading}
                eagerLoadImage={eagerLoadImage}
            />
        </div>
    );
};
